import {TFunction} from "i18next"
import {AuthContextValue} from "../../context/AuthProvider"

export type NavigationSection =
    | "workspace"
    | "administration"

export type NavigationItem = {
    id: string
    section: NavigationSection
    to: string
    icon: string
    label: string
    visible: boolean
}

export const getNavigationItems = (
    auth: AuthContextValue,
    t: TFunction
): NavigationItem[] => {
    return [
        {
            id: "statistics",
            section: "workspace",
            to: "/statistics",
            icon: "bi-pie-chart",
            label: t("statistics", {ns: "navigation"}),
            visible: auth.isAuthenticated(),
        },
        {
            id: "exam-management",
            section: "workspace",
            to: "/exam-management",
            icon: "bi-clipboard-data",
            label: t("dean", {ns: "navigation"}),
            visible: auth.hasAnyPermission([
                "examManagement",
                "dean",
                "infrastructure",
                "examOfficeEmployee",
                "examOfficeAssistant",
            ]),
        },
        // {
        //     id: "current-exams",
        //     section: "workspace",
        //     to: "/current-exams",
        //     icon: "bi-display",
        //     label: t("currentExams", {ns: "navigation"}),
        //     visible: auth.hasPermission("infrastructure"),
        // },
        // {
        //     id: "rooms",
        //     section: "workspace",
        //     to: "/rooms",
        //     icon: "bi-door-open",
        //     label: t("myRooms", {ns: "navigation"}),
        //     visible: auth.hasPermission("managesRoom"),
        // },
        // {
        //     id: "supervision-employee",
        //     section: "workspace",
        //     to: "/supervision",
        //     icon: "bi-person-workspace",
        //     label: t("supervision.title", {ns: "common"}),
        //     visible: auth.hasPermission("examOfficeEmployee"),
        // },
        // {
        //     id: "supervision-assistant",
        //     section: "workspace",
        //     to: "/supervision",
        //     icon: "bi-person-badge",
        //     label: t("supervision.title", {ns: "common"}),
        //     visible: auth.hasPermission("examOfficeAssistant"),
        // },
        {
            id: "tenants",
            section: "workspace",
            to: "/tenants",
            icon: "bi-diagram-3",
            label: t("overview.title", {ns: "tenant"}),
            visible: auth.hasAnyPermission(["facultyOwner", "deputy"]),
        },
        {
            id: "admin-calendar",
            section: "administration",
            to: "/admin/calendar",
            icon: "bi-calendar-range",
            label: t("bookingCalendar", {ns: "navigation"}),
            visible: auth.hasPermission("admin"),
        },
        {
            id: "admin-users",
            section: "administration",
            to: "/admin/users",
            icon: "bi-people",
            label: t("userManagement", {ns: "navigation"}),
            visible: auth.hasPermission("admin"),
        },
        {
            id: "admin-mail-queue",
            section: "administration",
            to: "/admin/mail-queue",
            icon: "bi-inboxes",
            label: t("mailQueue", {ns: "navigation"}),
            visible: auth.hasGate("admin"),
        },
        {
            id: "admin-test-mails",
            section: "administration",
            to: "/admin/test-mails",
            icon: "bi-envelope-paper",
            label: t("testMailManagement", {ns: "navigation"}),
            visible: auth.hasGate("admin"),
        },
        {
            id: "admin-evaluations",
            section: "administration",
            to: "/admin/evaluations",
            icon: "bi-chat-square-text",
            label: t("evaluationManagement", {ns: "navigation"}),
            visible: auth.hasGate("admin"),
        },
        {
            id: "admin-rooms",
            section: "administration",
            to: "/admin/rooms",
            icon: "bi-door-open",
            label: t("roomManagement", {ns: "navigation"}),
            visible: auth.hasAnyPermission([
                "examOfficeEmployee",
                "examOfficeAssistant",
            ]),
        },
        {
            id: "admin-schedulers",
            section: "administration",
            to: "/admin/schedulers",
            icon: "bi-clock-history",
            label: t("scheduler", {ns: "navigation"}),
            visible: auth.hasGate("admin"),
        },
        {
            id: "admin-tucan-exam-rooms",
            section: "administration",
            to: "/admin/tucan-exam-rooms",
            icon: "bi-calendar2-week",
            label: t("tucanExamRooms", {ns: "navigation"}),
            visible: auth.hasGate("admin"),
        },
        {
            id: "admin-tucan-miner",
            section: "administration",
            to: "/admin/tucan-miner",
            icon: "bi-cloud-download",
            label: t("tucanMiner", {ns: "navigation"}),
            visible: auth.hasGate("admin"),
        },
        {
            id: "admin-tucan-exam-archive",
            section: "administration",
            to: "/admin/tucan-exam-archive",
            icon: "bi-graph-up-arrow",
            label: t("tucanExamArchive", {ns: "navigation"}),
            visible: auth.hasGate("admin"),
        },
        {
            id: "admin-room-power-planning",
            section: "administration",
            to: "/admin/room-power-planning",
            icon: "bi-bezier2",
            label: t("roomPowerPlanning", {ns: "navigation"}),
            visible: auth.hasGate("admin"),
        },
        {
            id: "admin-buildings",
            section: "administration",
            to: "/admin/buildings",
            icon: "bi-building",
            label: t("buildings", {ns: "navigation"}),
            visible: auth.hasAnyPermission([
                "examOfficeEmployee",
                "examOfficeAssistant",
            ]),
        },
        {
            id: "admin-exam-paster",
            section: "administration",
            to: "/admin/debug/exampaster",
            icon: "bi-clipboard2-pulse",
            label: t("examPaster", {ns: "navigation"}),
            visible: auth.hasPermission("examOfficeAssistant"),
        },
        {
            id: "admin-photo-id-guide",
            section: "administration",
            to: "/admin/debug/photo-id-guide",
            icon: "bi-person-vcard",
            label: t("photoIdGuide", {ns: "navigation"}),
            visible: auth.hasPermission("examOfficeAssistant"),
        },
    ]
}
